import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import {ProcessFlowStepType} from '../../../enums/processFlowStepType'
import {IProcessFlowStepConstructorOptions, IRunProcess, IShallowProcessFlow} from '~/interfaces/processFlowInterfaces'
import ProcessFlow from "~/models/processFlows/processFlow";
import {IOVariableLink} from "~/models/processFlows/IOVariableLink";
import {Hash} from "~/interfaces/hashInterfaces";

export class ProcessFlowRunProcessStep extends ProcessFlowStep implements IRunProcess {
  step_type: ProcessFlowStepType.RunProcess
  linked_process_flow_id: string;
  io_variable_links: Hash<IOVariableLink> = {};

  constructor(parent, options: IProcessFlowStepConstructorOptions) {
    super(parent, options);
    this.defineProperty('linked_process_flow_id', null);
  }

  get defaultTitle(): string {
    return `Run ${this.linkedProcessFlow?.titleOrDefault || 'Process'}`
  }

  get linkedProcessFlow(): ProcessFlow {
    return ProcessFlow.repo.findById(this.linked_process_flow_id);
  }

  get allProcessFlowIds(): Array<string> {
    const ids = []
    if (this.linked_process_flow_id) ids.push(this.linked_process_flow_id)
    return ids
  }
}